module.exports = __webpack_public_path__ + "static/img/icon-close_white.b26fa5c6.svg";